import { useState } from 'react';

import apiCollection from 'api';
import strings from 'lang/lang';
import { DropDown } from 'elements';
import { showError } from 'elements/Toasts/toastActions';
import { ReactComponent as PostmanIcon } from 'styles/icon/header/postman.svg';

import postman from './Postman.module.scss';

const downloadPostmanCollection = function (apiId) {
  return apiCollection.portal
    .downloadPostmanCollection(apiId)
    .then((response) => {
      if (response.status === 200) {
        return response.blob();
      } else if (response.status === 401) {
        throw new Error(strings.apiConsoleContainer.errors.sessionNotActive);
      } else {
        console.error('error downloading collection', response);
        const errorMessage = `Postman collection not exists for API "${apiId}"`;
        throw new Error(errorMessage);
      }
    })
    .then((blob) => {
      return URL.createObjectURL(blob);
    })
    .then((url) => {
      let fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = `${apiId}_postmanCollection.json`;
      fileLink.click();
      URL.revokeObjectURL(url);
    })
    .catch((error) => {
      showError(error.data.message);
    });
};

const PostmanCollection = ({ api = {} }) => {
  const [isOpened, toogleDropdown] = useState(false);

  return (
    <DropDown
      trigger={() => (
        <button className={postman.postman__btn}>
          <PostmanIcon />
          <span className={postman.postman__text}>Postman Collection</span>
        </button>
      )}
      className={postman.postman}
      classNameBody={postman.postman__body}
      onTriggerClick={() => toogleDropdown(!isOpened)}
      handleClose={() => toogleDropdown(false)}
      isOpened={isOpened}
    >
      <div
        className={postman.postman__link}
        onClick={() => {
          toogleDropdown(false);
          downloadPostmanCollection(api.postmanCollectionFileName);
        }}
      >
        Download
      </div>

      <a
        className={postman.postman__link}
        href={'https://app.getpostman.com/run-collection/' + api.postmanCollectionId}
        target="_blank"
        onClick={() => {
          toogleDropdown(false);
        }}
      >
        Run in Postman
      </a>
    </DropDown>
  );
};

export default PostmanCollection;
